import React from 'react';
import { Box, Stack } from '@mui/material';
import ConnectionActiveImports from '@features/connections/generic/components/ConnectionActiveImports';
import {
  isTerminalImportJob,
  useConnectionImportJobs,
} from '@features/connections/hooks/useConnectionImportJobs';
import { APP_CONFIG } from '../../../config/app.config';
import DashboardCardHeader from './general/DashboardCardHeader';

/**
 * Dashboard card listing in-progress store imports. Hidden when nothing is running.
 */
const DashboardActiveImports: React.FC = () => {
  const colors = APP_CONFIG.ui.theme.colors;
  const { activeJobs, displayJobs, isFetched } = useConnectionImportJobs();

  const hasRunningImports =
    activeJobs.length > 0 ||
    displayJobs.some((job) => !isTerminalImportJob(job));

  if (!isFetched || !hasRunningImports) {
    return null;
  }

  return (
    <Box
      sx={{
        border: `1px solid ${colors.border}`,
        borderRadius: '16px',
        overflow: 'hidden',
        width: '100%',
        bgcolor: colors.background,
      }}
    >
      <DashboardCardHeader title="Importing your data" divider />

      <Stack sx={{ maxHeight: '220px', overflow: 'auto' }}>
        <ConnectionActiveImports />
      </Stack>
    </Box>
  );
};

export default DashboardActiveImports;
